var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiarytreeLogo25X25Cropped(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    zoomAndPan: "magnify",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "99.66 107.88 172.41 161.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d9f677b2b3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 122.070312 119.59375 L 272.070312 119.59375 L 272.070312 269.59375 L 122.070312 269.59375 Z M 122.070312 119.59375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "54a64710ec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 122.070312 157 L 160 157 L 160 269.59375 L 122.070312 269.59375 Z M 122.070312 157 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a8d046bd15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 142.03125 148.277344 L 148.945312 148.277344 L 148.945312 155.1875 L 142.03125 155.1875 Z M 142.03125 148.277344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "57036cbfc9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 145.488281 148.277344 L 146.585938 150.632812 L 148.945312 151.734375 L 146.585938 152.832031 L 145.488281 155.1875 L 144.386719 152.832031 L 142.03125 151.734375 L 144.386719 150.632812 Z M 145.488281 148.277344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1e6b948fa3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 136.511719 139.925781 L 144.863281 139.925781 L 144.863281 148.277344 L 136.511719 148.277344 Z M 136.511719 139.925781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2f8f41582b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 140.6875 139.925781 L 142.015625 142.773438 L 144.863281 144.101562 L 142.015625 145.429688 L 140.6875 148.277344 L 139.359375 145.429688 L 136.511719 144.101562 L 139.359375 142.773438 Z M 140.6875 139.925781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b1143000e7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 114.101562 158.171875 L 126.660156 158.171875 L 126.660156 170.730469 L 114.101562 170.730469 Z M 114.101562 158.171875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "70baef7632"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 120.378906 158.171875 L 122.378906 162.453125 L 126.660156 164.453125 L 122.378906 166.449219 L 120.378906 170.730469 L 118.382812 166.449219 L 114.101562 164.453125 L 118.382812 162.453125 Z M 120.378906 158.171875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9a7ac280c3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 145.488281 155.582031 L 152.398438 155.582031 L 152.398438 162.496094 L 145.488281 162.496094 Z M 145.488281 155.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e7b2e67a05"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 148.945312 155.582031 L 150.042969 157.941406 L 152.398438 159.039062 L 150.042969 160.140625 L 148.945312 162.496094 L 147.84375 160.140625 L 145.488281 159.039062 L 147.84375 157.941406 Z M 148.945312 155.582031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7849a088e8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 139.378906 160.996094 L 146.292969 160.996094 L 146.292969 167.910156 L 139.378906 167.910156 Z M 139.378906 160.996094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "24a967f87b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 142.835938 160.996094 L 143.933594 163.351562 L 146.292969 164.453125 L 143.933594 165.550781 L 142.835938 167.910156 L 141.734375 165.550781 L 139.378906 164.453125 L 141.734375 163.351562 Z M 142.835938 160.996094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "40f1800c27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 136.511719 153.363281 L 143.421875 153.363281 L 143.421875 160.277344 L 136.511719 160.277344 Z M 136.511719 153.363281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9cec04c2df"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 139.96875 153.363281 L 141.066406 155.71875 L 143.421875 156.820312 L 141.066406 157.921875 L 139.96875 160.277344 L 138.867188 157.921875 L 136.511719 156.820312 L 138.867188 155.71875 Z M 139.96875 153.363281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d250958b63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 128.160156 146.835938 L 136.511719 146.835938 L 136.511719 155.1875 L 128.160156 155.1875 Z M 128.160156 146.835938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1e3b39c9e5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 132.335938 146.835938 L 133.664062 149.683594 L 136.511719 151.011719 L 133.664062 152.34375 L 132.335938 155.1875 L 131.007812 152.34375 L 128.160156 151.011719 L 131.007812 149.683594 Z M 132.335938 146.835938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "31dd7e88af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 126.660156 156.820312 L 135.011719 156.820312 L 135.011719 165.171875 L 126.660156 165.171875 Z M 126.660156 156.820312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b2a2b82d1b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 130.835938 156.820312 L 132.164062 159.667969 L 135.011719 160.996094 L 132.164062 162.324219 L 130.835938 165.171875 L 129.507812 162.324219 L 126.660156 160.996094 L 129.507812 159.667969 Z M 130.835938 156.820312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "09c114f7f4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 131.617188 166.144531 L 139.96875 166.144531 L 139.96875 174.496094 L 131.617188 174.496094 Z M 131.617188 166.144531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f06fa64d94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 135.792969 166.144531 L 137.121094 168.992188 L 139.96875 170.320312 L 137.121094 171.648438 L 135.792969 174.496094 L 134.460938 171.648438 L 131.617188 170.320312 L 134.460938 168.992188 Z M 135.792969 166.144531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "10f9c28cdc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 123.234375 130.644531 L 135.792969 130.644531 L 135.792969 143.203125 L 123.234375 143.203125 Z M 123.234375 130.644531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2a74555ace"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 129.511719 130.644531 L 131.511719 134.925781 L 135.792969 136.925781 L 131.511719 138.921875 L 129.511719 143.203125 L 127.515625 138.921875 L 123.234375 136.925781 L 127.515625 134.925781 Z M 129.511719 130.644531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3db35663af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 119.058594 172.804688 L 131.617188 172.804688 L 131.617188 185.363281 L 119.058594 185.363281 Z M 119.058594 172.804688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f6e783ce73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 125.335938 172.804688 L 127.335938 177.085938 L 131.617188 179.085938 L 127.335938 181.082031 L 125.335938 185.363281 L 123.339844 181.082031 L 119.058594 179.085938 L 123.339844 177.085938 Z M 125.335938 172.804688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e0181879ee"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 113.351562 141.246094 L 125.910156 141.246094 L 125.910156 153.804688 L 113.351562 153.804688 Z M 113.351562 141.246094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c69fac562d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 119.628906 141.246094 L 121.628906 145.527344 L 125.910156 147.527344 L 121.628906 149.523438 L 119.628906 153.804688 L 117.632812 149.523438 L 113.351562 147.527344 L 117.632812 145.527344 Z M 119.628906 141.246094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d8cd50dae7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 112.222656 123.058594 L 126.660156 123.058594 L 126.660156 137.496094 L 112.222656 137.496094 Z M 112.222656 123.058594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a8867b90cc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 119.441406 123.058594 L 121.738281 127.980469 L 126.660156 130.277344 L 121.738281 132.574219 L 119.441406 137.496094 L 117.144531 132.574219 L 112.222656 130.277344 L 117.144531 127.980469 Z M 119.441406 123.058594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "102e59799c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 112.222656 107.875 L 126.660156 107.875 L 126.660156 122.308594 L 112.222656 122.308594 Z M 112.222656 107.875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "766b818312"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 119.441406 107.875 L 121.738281 112.796875 L 126.660156 115.09375 L 121.738281 117.390625 L 119.441406 122.308594 L 117.144531 117.390625 L 112.222656 115.09375 L 117.144531 112.796875 Z M 119.441406 107.875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0d2f813ce0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 102.046875 133.839844 L 116.484375 133.839844 L 116.484375 148.277344 L 102.046875 148.277344 Z M 102.046875 133.839844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f83ab124d7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 109.265625 133.839844 L 111.5625 138.761719 L 116.484375 141.058594 L 111.5625 143.355469 L 109.265625 148.277344 L 106.96875 143.355469 L 102.046875 141.058594 L 106.96875 138.761719 Z M 109.265625 133.839844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e5123b6223"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 105.191406 149.601562 L 119.628906 149.601562 L 119.628906 164.039062 L 105.191406 164.039062 Z M 105.191406 149.601562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "351ad77e65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 112.410156 149.601562 L 114.707031 154.523438 L 119.628906 156.820312 L 114.707031 159.117188 L 112.410156 164.039062 L 110.113281 159.117188 L 105.191406 156.820312 L 110.113281 154.523438 Z M 112.410156 149.601562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0dbce86f7d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106.882812 167.910156 L 121.320312 167.910156 L 121.320312 182.34375 L 106.882812 182.34375 Z M 106.882812 167.910156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c03fd6a215"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 114.101562 167.910156 L 116.398438 172.828125 L 121.320312 175.125 L 116.398438 177.421875 L 114.101562 182.34375 L 111.804688 177.421875 L 106.882812 175.125 L 111.804688 172.828125 Z M 114.101562 167.910156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7f83574116"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 99.664062 114.152344 L 114.101562 114.152344 L 114.101562 128.589844 L 99.664062 128.589844 Z M 99.664062 114.152344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ff861f2d35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106.882812 114.152344 L 109.179688 119.074219 L 114.101562 121.371094 L 109.179688 123.667969 L 106.882812 128.589844 L 104.585938 123.667969 L 99.664062 121.371094 L 104.585938 119.074219 Z M 106.882812 114.152344 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d9f677b2b3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#335c6e",
    d: "M 197.070312 119.59375 L 122.070312 119.59375 L 159.570312 157.09375 L 197.070312 157.09375 C 217.78125 157.09375 234.570312 173.882812 234.570312 194.59375 C 234.570312 215.300781 217.78125 232.09375 197.070312 232.09375 L 159.613281 232.09375 L 159.570312 232.203125 L 159.613281 232.09375 L 122.070312 269.59375 L 197.070312 269.59375 C 238.492188 269.59375 272.070312 236.015625 272.070312 194.59375 C 272.070312 153.171875 238.492188 119.59375 197.070312 119.59375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#54a64710ec)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#335c6e",
    d: "M 159.570312 232.203125 L 122.070312 269.59375 L 122.070312 194.59375 L 159.570312 157.09375 L 159.570312 232.203125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a8d046bd15)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#57036cbfc9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e53c73",
    d: "M 142.03125 148.277344 L 148.945312 148.277344 L 148.945312 155.1875 L 142.03125 155.1875 Z M 142.03125 148.277344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1e6b948fa3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2f8f41582b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e53c73",
    d: "M 136.511719 139.925781 L 144.863281 139.925781 L 144.863281 148.277344 L 136.511719 148.277344 Z M 136.511719 139.925781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b1143000e7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#70baef7632)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e53c73",
    d: "M 114.101562 158.171875 L 126.660156 158.171875 L 126.660156 170.730469 L 114.101562 170.730469 Z M 114.101562 158.171875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9a7ac280c3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e7b2e67a05)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e53c73",
    d: "M 145.488281 155.582031 L 152.398438 155.582031 L 152.398438 162.496094 L 145.488281 162.496094 Z M 145.488281 155.582031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7849a088e8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#24a967f87b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e53c73",
    d: "M 139.378906 160.996094 L 146.292969 160.996094 L 146.292969 167.910156 L 139.378906 167.910156 Z M 139.378906 160.996094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#40f1800c27)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9cec04c2df)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e53c73",
    d: "M 136.511719 153.363281 L 143.421875 153.363281 L 143.421875 160.277344 L 136.511719 160.277344 Z M 136.511719 153.363281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d250958b63)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1e3b39c9e5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e53c73",
    d: "M 128.160156 146.835938 L 136.511719 146.835938 L 136.511719 155.1875 L 128.160156 155.1875 Z M 128.160156 146.835938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#31dd7e88af)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b2a2b82d1b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e53c73",
    d: "M 126.660156 156.820312 L 135.011719 156.820312 L 135.011719 165.171875 L 126.660156 165.171875 Z M 126.660156 156.820312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#09c114f7f4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f06fa64d94)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e53c73",
    d: "M 131.617188 166.144531 L 139.96875 166.144531 L 139.96875 174.496094 L 131.617188 174.496094 Z M 131.617188 166.144531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#10f9c28cdc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2a74555ace)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e53c73",
    d: "M 123.234375 130.644531 L 135.792969 130.644531 L 135.792969 143.203125 L 123.234375 143.203125 Z M 123.234375 130.644531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3db35663af)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f6e783ce73)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e53c73",
    d: "M 119.058594 172.804688 L 131.617188 172.804688 L 131.617188 185.363281 L 119.058594 185.363281 Z M 119.058594 172.804688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e0181879ee)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c69fac562d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e53c73",
    d: "M 113.351562 141.246094 L 125.910156 141.246094 L 125.910156 153.804688 L 113.351562 153.804688 Z M 113.351562 141.246094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d8cd50dae7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a8867b90cc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e53c73",
    d: "M 112.222656 123.058594 L 126.660156 123.058594 L 126.660156 137.496094 L 112.222656 137.496094 Z M 112.222656 123.058594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#102e59799c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#766b818312)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e53c73",
    d: "M 112.222656 107.875 L 126.660156 107.875 L 126.660156 122.308594 L 112.222656 122.308594 Z M 112.222656 107.875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0d2f813ce0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f83ab124d7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e53c73",
    d: "M 102.046875 133.839844 L 116.484375 133.839844 L 116.484375 148.277344 L 102.046875 148.277344 Z M 102.046875 133.839844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e5123b6223)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#351ad77e65)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e53c73",
    d: "M 105.191406 149.601562 L 119.628906 149.601562 L 119.628906 164.039062 L 105.191406 164.039062 Z M 105.191406 149.601562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0dbce86f7d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c03fd6a215)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e53c73",
    d: "M 106.882812 167.910156 L 121.320312 167.910156 L 121.320312 182.34375 L 106.882812 182.34375 Z M 106.882812 167.910156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7f83574116)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ff861f2d35)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e53c73",
    d: "M 99.664062 114.152344 L 114.101562 114.152344 L 114.101562 128.589844 L 99.664062 128.589844 Z M 99.664062 114.152344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiarytreeLogo25X25Cropped);
export default __webpack_public_path__ + "static/media/diarytree_logo25x25-cropped.c4d260a8d851550c7d5eef1502ad5552.svg";
export { ForwardRef as ReactComponent };